import apiClient from './apiClient';

export interface AdminOrder {
  id: string;
  customer_id: string;
  product_id: string;
  quantity: number;
  total_price: number;
  status: string;
  total_amount?: number;
  payment_status?: string;
  delivery_address?: string;
  requested_delivery_date?: string;
  created_at?: string;
}

export const listOrders = async (): Promise<AdminOrder[]> => {
  const response = await apiClient.get('/operations/orders/');
  return response.data;
};

export const updateOrderStatus = async (orderId: string, status: string): Promise<AdminOrder> => {
  const response = await apiClient.put(`/operations/orders/${orderId}/status`, { status });
  return response.data;
};
